<template>
  <div class="base-footer">
    <BaseFooterTitle class="tt" />
    <BaseKinostart class="kinostart" :kinostart="kinostart" />
    <component class="nav" :is="companyNav"></component>
    <BaseFooterCline class="cline" />
    <div class="cb-restore"></div>
  </div>
</template>

<script>
export default {
  props: {
    kinostart: {
      type: String,
      default: 'Releaseline',
    },
  },
  computed: {
    companyNav() {
      return () =>
        import(
          `@/website_elements/global/companies/${this.$config.verantwortlich.toLowerCase()}/FooterNav.vue`
        )
    },
  },
}
</script>

<style lang="scss" scoped>
.base-footer {
  position: relative;
  width: 100%;
  text-align: center;
  .tt,
  .nav,
  .kinostart,
  .cline {
    margin-bottom: 1.2em;
  }
}
</style>
